const properties = {
  ...process.env,
};

function getProperties() {
  return properties;
}

function getProperty(property) {
  return getProperties()[property] || null;
}

export { getProperty, getProperties };
